import CargoCompanyListResponse, {
  CargoCompanyListResponseItem,
} from "../../../../api/raily/cargo-company/cargo-company/list/cargo-company-list.response";
import CargoCompanyList, { CargoCompanyListItem } from "./cargo-company-list";

const createDataItem = (
  responseItem: CargoCompanyListResponseItem
): CargoCompanyListItem => {
  return {
    uuid: responseItem.id,
    address: responseItem.headquartersAddressString,
    companyId: responseItem.regon,
    nationalCourtRegister: responseItem.krsNo,
    displayName: responseItem.displayName,
    name: responseItem.companyName,
    notes: responseItem.notes,
    taxNumber: responseItem.taxId,
  };
};

const createData = (
  responseData: CargoCompanyListResponseItem[]
): CargoCompanyListItem[] => {
  return responseData.map(createDataItem);
};

const create = (response: CargoCompanyListResponse): CargoCompanyList => {
  return {
    data: createData(response.data),
  };
};

const cargoCompanyListFactory = {
  create,
};

export default cargoCompanyListFactory;
